import { render, staticRenderFns } from "./InvalidSignature.vue?vue&type=template&id=ba57e41a&scoped=true&"
import script from "./InvalidSignature.vue?vue&type=script&lang=js&"
export * from "./InvalidSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba57e41a",
  null
  
)

export default component.exports